const portfolioArray = [
   {
    src: "https://jdfunnel.netlify.app/",
    technology: "REACT, MUI, Redux, Laravel",
    projectname: "Jd Funnel App",
    projectdetail:
      "This is front end page of Medicine donation. this project is client base project",
  },
  {
    src: "https://maqboolsite.netlify.app/",
    technology: "Emotion, Redux, Next.js, React",
    projectname: "Client Portfolio",
    projectdetail: "Using Emotion, Redux, Next.js, React to complete this project",
  },
   {
    src: "https://jobportalwebapp.netlify.app/",
    technology: "MERN STACK, REACT & MUI",
    projectname: "Job Portal web app",
    projectdetail:
      "this is job portal web app project using react js and material ui",
  },
  
  {
    src: "https://mystweb.netlify.app/",
    technology: "REACT & MUI",
    projectname: "Mystweb App",
    projectdetail: "this is Mystweb App project using react js and material ui",
  },
  {
    src: "https://bitcoin_intro.surge.sh/",
    technology: "REACT & MUI",
    projectname: "Bit Coin Intro",
    projectdetail: "This is front end of bitcoin project",
  },
  {
    src: "https://recruiteq.netlify.app/",
    technology: "REACT & MUI",
    projectname: "Recruiteq FrontEnd",
    projectdetail:
      "To complete this project using React TS and MUI. Recruiteq project is client base project",
  },
  
  {
    src: "https://bazarwebapp.netlify.app/",
    technology: "REACT, Context API, MUI Theme",
    projectname: "Grocery Store",
    projectdetail:
      "this is Grocery Store project using react js, Context Api and material ui with theme",
  },
  
  {
    src: "https://tenup.netlify.app/",
    technology: "REACT & MUI",
    projectname: "TENUP",
    projectdetail: "Using React js and Material UI to complete this project",
  },
  
  {
    src: "https://quizapp-typescript.netlify.app/",
    technology: "REACT TS & MUI",
    projectname: "Quiz App",
    projectdetail:
      "Using React TS and MUI to complete this project. using this project a user take quiz and solve quiz and also check score.",
  },
];
export default portfolioArray;
